import { createFileRoute } from "@tanstack/react-router";
import { tabSearch } from "@/app/tabs";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";

/**
 * `/catalogue` — the product list and the price list, one surface, two tabs.
 *
 * THE ADDRESS EXISTS BEFORE THE SCREEN DOES, which is the whole argument
 * `app/tabs.ts` makes for the vocabularies: this surface's two ids were
 * Inventory's until the POC moved them, and every link the POC's users hold to
 * `?tab=products` or `?tab=pricing` has to mean the right place on the day this
 * repo ships — not on the day the screen is built. `/inventory` redirects those
 * three ids here already (see its route), while both pages are placeholders.
 *
 * `VIEW_INVENTORY` and not a right of its own: it is what opens the shelf AND
 * the list of what may go on it. See `app/nav.ts`.
 */
export const Route = createFileRoute("/_authenticated/catalogue")({
  // Its own vocabulary, so `?tab=formulary` resolves here — retired once when
  // the product list stopped being only medicines, and again when it left the
  // shelf. `app/tabs.ts`.
  validateSearch: tabSearch("catalogue"),
  beforeLoad: requirePerm("VIEW_INVENTORY"),
  component: () => <PendingSurface titleKey="nav.catalogue" />,
});
